import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Award, ShieldCheck, Settings, Globe, Users } from 'lucide-react'; // Agar lucide-react icons use nahi ho rahe toh aap SVG ya apni icons use kar sakte hain

// Number Counter Component for Animation
const Counter = ({ value }) => {
    const count = useMotionValue(0);
    const rounded = useTransform(count, (latest) => Math.floor(latest));
    const [displayValue, setDisplayValue] = useState(0);

    useEffect(() => {
        const controls = animate(count, value, { duration: 2 });
        return controls.stop;
    }, [count, value]);

    useEffect(() => {
        return rounded.onChange((latest) => {
            setDisplayValue(latest);
        });
    }, [rounded]);

    return <span>{displayValue}</span>;
};

const WhyChooseUs = () => {
    // Stats array based on your provided image layout
    const stats = [
        {
            icon: <Award className="w-8 h-8 text-blue-400 mx-auto mb-2" />,
            number: 25,
            suffix: "+",
            title: "Years of Experience"
        },
        {
            icon: <ShieldCheck className="w-8 h-8 text-blue-400 mx-auto mb-2" />,
            number: 9001,
            prefix: "ISO ",
            title: "Certified Company"
        },
        {
            icon: <Settings className="w-8 h-8 text-blue-400 mx-auto mb-2" />,
            number: 100,
            suffix: "+",
            title: "High Quality Products"
        },
        {
            icon: <Globe className="w-8 h-8 text-blue-400 mx-auto mb-2" />,
            number: 20,
            suffix: "+",
            title: "Countries Served"
        },
        {
            icon: <Users className="w-8 h-8 text-blue-400 mx-auto mb-2" />,
            number: 500,
            suffix: "+",
            title: "Satisfied Clients"
        }
    ];

    return (
        <section className="py-20 bg-[url('/public/banner.jpg')] bg-cover bg-center relative">
            {/* Dark Overlay taaki text clear dikhe */}
            <div className="absolute inset-0 bg-blue-950/90"></div>

            <div className="container mx-auto px-6 lg:px-12 relative z-10 text-white">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">

                    {/* Left Column: Heading, Description & Button */}
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                        className="lg:col-span-5 border-b lg:border-b-0 lg:border-r border-white/20 pb-10 lg:pb-0 lg:pr-10"
                    >
                        <span className="text-blue-400 font-semibold tracking-wider text-sm uppercase block mb-2">
                            WHY LEV INDIA?
                        </span>
                        <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-6 leading-tight">
                            Built on Quality. Driven by Trust.
                        </h2>
                        <p className="text-blue-100 text-sm md:text-base leading-relaxed mb-8">
                            We are committed to delivering products that meet international standards and exceed customer expectations.
                        </p>

                        <Link to="/about">
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className="inline-flex items-center gap-3 px-6 py-3 border-2 border-white/30 rounded-full font-medium text-white hover:bg-white hover:text-blue-950 transition duration-300"
                            >
                                Know More About Us
                                <span className="text-lg">→</span>
                            </motion.button>
                        </Link>
                    </motion.div>

                    {/* Right Column: Animated Stats / Features Grid */}
                    <div className="lg:col-span-7">
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
                            {stats.map((item, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.1, duration: 0.5 }}
                                    className="p-6 bg-white/5 backdrop-blur-md rounded-2xl border border-white/10 hover:bg-white/10 transition text-center flex flex-col items-center justify-center"
                                >
                                    {item.icon}
                                    <h3 className="text-2xl md:text-3xl font-bold text-white mb-1">
                                        {item.prefix || ""}<Counter value={item.number} />{item.suffix || ""}
                                    </h3>
                                    <p className="text-blue-200 text-xs md:text-sm font-medium">{item.title}</p>
                                </motion.div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;